import Vue from "vue";
import Router from "vue-router";
import base from "./modules/base";

Vue.use(Router);
// 基础路由
export const constantRoutes = [...base];

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });
const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
